import React from 'react';
import { InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CustomTimePicker from '../../../../../../components/CustomTimePicker';
import { CustomTextField } from '../../../../../../components/CustomTextField';
import { CustomSelect } from '../../../../../../components/CustomSelect';
import { userListToLabelEmailPhoneValue } from '../../../../../../Apis/functions';
import CustomAddChipSearch from '../../../../../../components/CustomAddChipSearch';
import { USER_TYPE_MODEL } from '../../../../../../enums/userTypeEnum';
import { PersonChipBlack } from '../../../../../../components/buttons/IconButtons';

const ShiftTimePicker = ({ readOnly, displayNone, emptyFields, item, handleChange, selectedList, setSelectedList }) => {
    const { t } = useTranslation();
    const { getAllDepartments: allDepartments } = useSelector((state) => state.DocumentPanelSlice);
    const isSameTime = item?.startShiftAt && item?.endShiftAt && item.startShiftAt === item.endShiftAt;

    return (
        <>
            {!displayNone && (
                <div className='col-12 col-md-12 mb-12'>
                    <CustomSelect
                        id='slt_stp_department'
                        value={item?.departmentId}
                        name={"departmentId"}
                        readOnly={readOnly}
                        disabled={readOnly}
                        onChange={handleChange}
                        trans='department'
                        list={allDepartments}
                        keyName='id'
                        required={true}
                        emptyFields={emptyFields}
                        showNoSelectionOption={false}
                    />
                </div>
            )}
            <div className='col-12 col-md-12 mb-12'>
                <CustomAddChipSearch
                    id='slt_stp_supervisor'
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    userTypeIdsSearch={[USER_TYPE_MODEL.EMPLOYEE]}
                    disabled={readOnly}
                    label='supervisor'
                    required={false}
                    reset={false}
                    hideButton={false}
                    keyId={'userId'}
                    showSubSection={true}
                    sanitizeDataList={userListToLabelEmailPhoneValue}
                    Icon={PersonChipBlack}
                    placeholder={t('search_employee_by_name_email_or_phone')}
                />
            </div>
            <div className='col-12 col-md-6 '>
                <CustomTimePicker
                    id='dtp_stp_start_shift_at'
                    title={t('starts_at')}
                    name={'startShiftAt'}
                    value={item?.startShiftAt}
                    handleChange={(value) => {
                        handleChange({ target: { value: value, name: 'startShiftAt' } });
                    }}
                    disabled={readOnly}
                    required={true}
                    emptyFields={emptyFields}
                    isValid={!isSameTime}
                    isValidText="end_date_cannot_be_before_start_date"
                />
            </div>
            <div className='col-12 col-md-6 '>
                <CustomTimePicker
                    id='dtp_stp_end_shift_at'
                    title={t('ends_at')}
                    name={'endShiftAt'}
                    value={item?.endShiftAt}
                    handleChange={(value) => {
                        handleChange({ target: { value: value, name: 'endShiftAt' } });
                    }}
                    disabled={readOnly}
                    required={true}
                    emptyFields={emptyFields}
                    isValid={!isSameTime}
                    isValidText="end_date_cannot_be_before_start_date"
                />
            </div>
            <div className='col-12 col-md-6'>
                <CustomTextField
                    id='txt_stp_tolerance'
                    label={t('tolerance')}
                    value={item?.range === 0 ? null : item?.range}
                    trans='tolerance'
                    name={'range'}
                    required={true}
                    emptyFields={emptyFields}
                    disabled={readOnly}
                    onChange={handleChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <span
                                    className={`ibl-font-w-700 ibl-h5 ${
                                        readOnly ? 'font-color-shades-300' : 'font-color-general-950'
                                    }`}
                                >
                                    {t('min')?.toUpperCase()}
                                </span>
                            </InputAdornment>
                        ),
                    }}
                    type='number'
                    length={3}
                    noUppercase={false}
                />
            </div>
            <div className='col-12 col-md-6'>
                <CustomTextField
                    id='txt_stp_checkout_extension_days'
                    label={t('checkout_extension_days')}
                    value={item?.checkoutExtensionDays}
                    trans='checkout_extension_days'
                    name='checkoutExtensionDays'
                    type='number'
                    disabled={readOnly}
                    onChange={handleChange}
                    helperText={'set_checkout_extension_days'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <span
                                    className={`ibl-font-w-700 ibl-h5 ${
                                        readOnly ? 'font-color-shades-300' : 'font-color-general-950'
                                    }`}
                                >
                                    {t('days')?.toUpperCase()}
                                </span>
                            </InputAdornment>
                        ),
                    }}
                    length={10}
                />
            </div>
        </>
    );
};

export default ShiftTimePicker;
